import { request } from '../http';
import type { Source } from '@/api/types/entities';

export type WorkspaceSourceRef = {
  id: string;
  name: string;
  displayName?: string | null;
  category?: string | null;
  isEnabled?: boolean;
};

export type WorkspaceEffectiveSources = {
  workspaceEnabledSources: WorkspaceSourceRef[];
  memberAssignedSources: WorkspaceSourceRef[];
  effectiveSources: WorkspaceSourceRef[];
  workspaceEnabledCount: number;
  memberAssignedCount: number;
};

export type WorkspaceSourcesSettings = {
  enabledSourceIds: string[];
  defaultMemberSourceIds: string[];
  availableSources: WorkspaceSourceRef[];
};

export function workspaceSourceToPickerSource(source: WorkspaceSourceRef): Source {
  return {
    id: source.id,
    name: source.name,
    base_url: '',
    category: source.category ?? 'other',
    is_enabled: source.isEnabled ?? true,
    policy_json: null,
  };
}

export function workspaceSourcesToPickerSources(sources: WorkspaceSourceRef[]): Source[] {
  return sources.map(workspaceSourceToPickerSource);
}

export const workspaceSourcesService = {
  effective: () => request<WorkspaceEffectiveSources>('/workspace/sources/effective'),
  getSettings: () => request<WorkspaceSourcesSettings>('/workspace/sources/settings'),
  updateSettings: (body: { enabledSourceIds: string[]; defaultMemberSourceIds: string[] }) =>
    request<WorkspaceSourcesSettings>('/workspace/sources/settings', {
      method: 'PUT',
      body: JSON.stringify(body),
    }),
};
